import { HAGAI_TESTIMONY } from './hagaiTestimony';

/** Partner slug → testimony bundle. Expand as more partners are added. */
const PARTNER_TESTIMONY = {
  'austin-remodel-pro': HAGAI_TESTIMONY,
};

export function getPartnerTestimony(slug) {
  return PARTNER_TESTIMONY[slug] || null;
}
